import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'
import updateDataWorkoutUtil from '../../../../../modules/workout/model/utils/update-data'
import updateDataPlanAction from '../../../../plans/actions/update-data'
import setReduxAction from '../../../../redux/actions/set'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import cloneIfCantEditWorkoutAction from '../clone-if-cant-edit'
import saveWorkoutAction from '../save'
import WORKOUTS_ACTION from '../../constants/action'
import getCurrentOrStartedWorkoutSelect from '../../selectors/get-current-or-started'

export default function updateDataWorkoutAction (params = {}) {
  return async (dispatch, getState) => {
    let workout = (
      params.workout || getCurrentOrStartedWorkoutSelect(getState())
    )
    workout = getInstanceReduxUtil(getState(), workout)

    if (!workout) {
      return
    }

    workout = await dispatch(cloneIfCantEditWorkoutAction({
      workout
    }))

    const updatedState = updateDataWorkoutUtil({
      state: getState(),
      workout
    })

    dispatch(setReduxAction({
      type: WORKOUTS_ACTION.UPDATE_DATA,
      payload: {
        value: updatedState
      }
    }))

    // If it's in a plan, update it
    if (isInPlanWorkoutUtil(workout)) {
      dispatch(updateDataPlanAction())
    }

    if (isNewReduxUtil(workout)) {
      dispatch(saveWorkoutAction(getIdReduxUtil(workout)))
    }
  }
}
